// The app's fixed top bar. Sticky elements (a table's toolbar and headers, galleries' toolbars) pin
// just under it. Below 900px (DEVICES.tableView) the mobile chrome scrolls away with the page, so they
// pin flush to the viewport instead.
export const TOP_BAR_HEIGHT = 50;
